import { useEffect, useState } from "react";
import type { ReactNode } from "react";

import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "~/components";

type DialogProps = {
    className?: string,
    open?: boolean;
    triggerButton?: boolean;
    onOpenChange?: any;
    trigger?: string;
    buttonClass?: string;
    variant?: "default" | "link" | "destructive" | "outline" | "secondary" | "ghost";
};

type ModalProps = DialogProps;

export default function Modal({
    className,
    open = false,
    onOpenChange,
    trigger,
    triggerButton = true,
    buttonClass,
    children,
}: ModalProps & { children: ReactNode }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {triggerButton && (
                <Button size="sm" className={buttonClass} onClick={() => onOpenChange(true)}>
                    {trigger}
                </Button>
            )}
            <DialogContent className={className}>{children}</DialogContent>
        </Dialog>
    );
}

export function useDialogState({ actionData, defaultOpen }) {
    const [open, onOpenChange] = useState(defaultOpen);
    useEffect(() => {
        if (actionData?.status === 200) {
            onOpenChange(false);
        }
    }, [actionData, actionData?.status]);
    return [open, onOpenChange];
}
